
import { useState } from 'react';
import { Doctor } from '@/types';

export const DEFAULT_DOCTOR: Omit<Doctor, 'id'> = {
  name: '',
  specialty: '',
  image: '',
  bio: '',
  weeklyOffDays: [],
  slotDuration: 30,
  startTime: "09:00",
  endTime: "17:00"
};

export const useDoctorFormState = () => {
  const [currentDoctor, setCurrentDoctor] = useState<Doctor | null>(null);
  const [newDoctor, setNewDoctor] = useState<Omit<Doctor, 'id'>>(DEFAULT_DOCTOR);
  
  // Input change handler
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setNewDoctor({
      ...newDoctor,
      [name]: value
    });
  };
  
  // Reset form handler
  const resetForm = () => {
    setCurrentDoctor(null);
    setNewDoctor(DEFAULT_DOCTOR);
  };
  
  return {
    currentDoctor,
    setCurrentDoctor,
    newDoctor,
    setNewDoctor,
    handleInputChange,
    resetForm
  };
};
